import { Controller, useFormContext } from 'react-hook-form';
import { Users01 } from '@untitledui/icons';
import { Input } from '@/components/base/input/input';
import { AUTH_FORM_SIZE } from '@/shared/config/auth-form';
import type { SignupFormValues } from '../schema';

export const Step10TamanhoTime = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="tamanhoTime"
      render={({ field }) => (
        <Input
          label="Tamanho do time"
          type="number"
          size={AUTH_FORM_SIZE}
          icon={Users01}
          placeholder="Ex.: 25"
          autoFocus
          inputMode="numeric"
          isInvalid={!!errors.tamanhoTime}
          hint={errors.tamanhoTime?.message ?? 'Quantidade total de colaboradores'}
          value={field.value === undefined || Number.isNaN(field.value) ? '' : String(field.value)}
          onChange={(next) => {
            const raw = typeof next === 'string' ? next : '';
            if (raw === '') {
              field.onChange(undefined);
              return;
            }
            const parsed = Number(raw);
            field.onChange(Number.isFinite(parsed) ? parsed : undefined);
          }}
          onBlur={field.onBlur}
          name={field.name}
        />
      )}
    />
  );
};
